import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602f5dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bind-main" }
const _hoisted_2 = { class: "user-info van-hairline--bottom" }
const _hoisted_3 = { class: "left-info" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.66667 6.66667C8.66667 4.45753 10.4575 2.66667 12.6667 2.66667C14.8758 2.66667 16.6667 4.45753 16.6667 6.66667C16.6667 8.8758 14.8758 10.6667 12.6667 10.6667C10.4575 10.6667 8.66667 8.8758 8.66667 6.66667ZM12.6667 0C8.98477 0 6 2.98477 6 6.66667C6 10.3486 8.98477 13.3333 12.6667 13.3333C16.3486 13.3333 19.3333 10.3486 19.3333 6.66667C19.3333 2.98477 16.3486 0 12.6667 0ZM7.33333 14.6667C5.41438 14.6667 3.5936 15.2514 2.22923 16.4064C0.843708 17.5792 0 19.285 0 21.3333V23.3333C0 24.4379 0.895433 25.3333 2 25.3333H23.3333C24.4379 25.3333 25.3333 24.4379 25.3333 23.3333V21.3333C25.3333 19.285 24.4896 17.5792 23.1041 16.4064C21.7397 15.2514 19.919 14.6667 18 14.6667H7.33333ZM2.66667 21.3333C2.66667 20.068 3.1661 19.1071 3.95215 18.4417C4.75936 17.7584 5.93858 17.3333 7.33333 17.3333H18C19.3948 17.3333 20.574 17.7584 21.3812 18.4417C22.1672 19.1071 22.6667 20.068 22.6667 21.3333V22.6667H2.66667V21.3333Z",
  fill: "black",
  "fill-opacity": "0.22"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "mobile"
}
const _hoisted_12 = {
  key: 0,
  class: "tag"
}
const _hoisted_13 = {
  key: 0,
  class: "message"
}
const _hoisted_14 = { class: "task-list" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = {
  key: 0,
  style: {"margin-right":"8px"}
}
const _hoisted_17 = { class: "ask-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "微信授权", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content van-hairline--bottom" }, [
  /*#__PURE__*/_createElementVNode("div", null, "极飞服务 申请获得以下权限"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("• "),
    /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "获得你的公开信息（昵称/头像/地区及性别）")
  ])
], -1))
const _hoisted_20 = { class: "button-wrap" }

import { useStore } from 'vuex'
import { Switch, Popup } from 'vant'
import { removeStorage } from '@/utils'
import { computed, ref, Ref } from 'vue'
import { TOKENKEY } from '@/config/constant'
import { commonErrorHandle } from '@/utils/error-handle'
import { ServiceSubscribeTypes } from '@/defination/wx-bind'
import { GetUserWxBindInfoResult, UserSubscribeType } from '@/types/wx-bind'
import { showConfirmModal, showToastLoading, clearToast, showToastSuccess } from '@/utils/tools'
import {
  getUserWxBindInfo,
  requestSubscribeService,
  requestUnSubscribeService,
  requestUnbindService,
} from '@/apis/wx-bind'

interface NoticeServiceListItem {
  value: boolean
  type: UserSubscribeType
  text: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'user-info',
  setup(__props) {

const $store = useStore()
const avatarSrc = ref('')
const hasBind = ref(false)
const userInfo: Ref<GetUserWxBindInfoResult | null> = ref(null)
const noticeServiceList: Ref<Array<NoticeServiceListItem>> = ref([])
const bindClass = computed(() => {
  return hasBind.value ? 'un-binded' : 'wait-bind'
})
const popupShow = ref(false)
const formatMobile = computed(() => {
  if (!userInfo.value) {
    return ''
  }
  return `${userInfo.value.mobile.slice(0, 3)}****${userInfo.value.mobile.slice(-4)}`
})
const bindText = computed(() => (hasBind.value ? '解绑' : '前往绑定'))

function bindButtonHandle() {
  if (hasBind.value) {
    unBindHandle()
  } else {
    popupShow.value = true
  }
}
async function switchChangeHandle(item: NoticeServiceListItem, value: boolean) {
  showToastLoading()
  try {
    value ? await requestSubscribeService(item.type) : await requestUnSubscribeService(item.type)
    item.value = value
    console.log('item', item, value)

    clearToast()
  } catch (error) {
    // console.log('error', error)
    commonErrorHandle(error)
  }
}
async function confirmHandle() {
  // 跳转到授权页面
  popupShow.value = false
  window.location.replace(
    'https://passport.xag.cn/wechat/oauth/authorize?callbackUrl=' +
      encodeURIComponent(`${location.origin}/wx-bind/user-info`)
  )
}
async function unBindHandle() {
  try {
    await showConfirmModal({
      title: '解绑账号',
      message: '解绑之后将无法收到维修服务进度通知确认绑定吗？',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  try {
    await requestUnbindService()
    showToastSuccess('解绑成功')
    $store.commit('setUserInfo')
    removeStorage(TOKENKEY)
    setTimeout(() => {
      initPageDetail()
    }, 2000)
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function initNoticeServiceList(data: GetUserWxBindInfoResult | null) {
  const subscribeTypeMap: Record<string, boolean> = data
    ? data.subscribe_type.reduce((result, type) => {
        result[type] = true
        return result
      }, {} as Record<string, boolean>)
    : {}
  noticeServiceList.value = [...ServiceSubscribeTypes].map((arr) => {
    const type = arr[0] as UserSubscribeType
    return {
      value: !!subscribeTypeMap[type],
      type,
      text: arr[1],
    }
  })
}
async function initPageDetail() {
  showToastLoading()
  try {
    const data = await getUserWxBindInfo()
    avatarSrc.value = data.avatar
    userInfo.value = data
    hasBind.value = data.is_auth
    // hasBind.value = true
    initNoticeServiceList(data)
  } catch (error) {
    console.log('error', error)
    initNoticeServiceList(null)
  }
  clearToast()
}
initPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (avatarSrc.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: avatarSrc.value,
                alt: ""
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(userInfo.value ? userInfo.value.realName : '游客模式'), 1),
          (userInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", null, _toDisplayString(_unref(formatMobile)), 1),
                (userInfo.value.is_identify)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "已实名"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["bind-button wait-bind", _unref(bindClass)]),
        onClick: bindButtonHandle
      }, _toDisplayString(_unref(bindText)), 3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["notice-wrap", hasBind.value ? 'hide-pt' : ''])
    }, [
      (!hasBind.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "授权微信并绑定极飞账号后可以订阅以下服务通知信息:"))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeServiceList.value, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "van-hairline--bottom",
            key: item.type
          }, [
            _createElementVNode("div", _hoisted_15, [
              (!hasBind.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "•"))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(item.text) + "通知 ", 1)
            ]),
            (hasBind.value)
              ? (_openBlock(), _createBlock(_unref(Switch), {
                  key: 0,
                  modelValue: item.value,
                  size: 22,
                  "active-color": "#00C378",
                  onChange: (value) => switchChangeHandle(item, value),
                  disabled: !hasBind.value
                }, null, 8, ["modelValue", "onChange", "disabled"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 2),
    _createVNode(_unref(Popup), {
      show: popupShow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((popupShow).value = $event)),
      class: "popup-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "cancel-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (popupShow.value = false))
            }, "拒绝"),
            _createElementVNode("div", {
              class: "confirm-button van-hairline--left",
              onClick: confirmHandle
            }, "确认")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})